import styled from '@emotion/styled';
import {ReactComponent as IconNoCard} from '../../assets/icons/ic_nopayments.svg';

export const IconNoPayments = styled(IconNoCard)`
  width: ${({theme}) => theme.icon.size.lg};
  height: ${({theme}) => theme.icon.size.lg};
  fill: ${({theme}) => theme.color.neutral.grey_900};
`;
